import React, { InputHTMLAttributes } from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Label = styled.label<{ $width?: number }>`
  display: block;
  width: ${(props) => (props.$width ? `${props.$width}px` : 'initial')};
  margin-left: 6px;
  white-space: nowrap;
`;

const RadioBtn = styled.label<{ $size: number }>`
  display: block;
  width: ${(props) => `${props.$size}px`};
  height: ${(props) => `${props.$size}px`};
  min-width: ${(props) => `${props.$size}px`};
  min-height: ${(props) => `${props.$size}px`};
  border: 1.5px solid ${(props) => props.theme.ui.input.borderColor};
  border-radius: 100%;
  padding: 3px;
  cursor: pointer;

  & > div {
    width: 100%;
    height: 100%;
    border-radius: 100%;
  }
`;

const Input = styled.input`
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  opacity: 0;

  &:checked + ${RadioBtn} > div {
    background-color: ${(props) => props.theme.global.mainColor};
  }

  &:disabled + ${RadioBtn} {
    background-color: ${(props) => props.theme.ui.input.disabledBgColor};
    cursor: default;

    & > div {
      opacity: 0.7;
    }
  }
`;

interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  label?: string;
  labelWidth?: number;
  size?: number;
}

const Radio = React.forwardRef(
  ({ id, label, labelWidth, size = 22, ...rest }: RadioProps, ref: React.ForwardedRef<HTMLInputElement>) => {
    return (
      <Container>
        <Input id={id} ref={ref} type="radio" {...rest} />
        <RadioBtn $size={size} htmlFor={id}>
          <div></div>
        </RadioBtn>
        {label && (
          <Label htmlFor={id} $width={labelWidth}>
            {label}
          </Label>
        )}
      </Container>
    );
  }
);

export default Radio;
